import { z } from 'zod';
export const LoginInput = z.object({ login: z.string().min(3).max(200), password: z.string().min(1).max(200) });
export const MfaVerifyInput = z.object({ mfa_token: z.string().min(10), codigo: z.string().regex(/^\d{6}$/) });
export const RefreshInput = z.object({ refresh_token: z.string().min(20).optional() });
export const EnlaceInput = z.object({ token: z.string().min(20) });
export const PasswordResetRequestInput = z.object({ login: z.string().min(3) });
export const PasswordResetInput = z.object({ token: z.string().min(20), password: z.string().min(12).max(200) });
export const EnrollmentCodeInput = z.object({ sociedad_id: z.string().uuid() });
export const EnrollInput = z.object({
    codigo: z.string().regex(/^[A-Z0-9]{8}$/),
    device_id: z.string().uuid(),
    clave_publica: z.string().regex(/^[A-Za-z0-9+/]{43}=$/), // Ed25519: clave pública cruda de 32 bytes en base64
    modelo: z.string().max(100).optional(),
    version_app: z.string().max(20).optional(),
});
export const TokensResponse = z.object({
    access_token: z.string(),
    refresh_token: z.string().optional(),
    expires_in: z.number().int(),
    token_type: z.literal('Bearer'),
});
export const MfaRequeridoResponse = z.object({ mfa_requerido: z.literal(true), mfa_token: z.string() });
//# sourceMappingURL=auth.js.map